import { Button, Container, Typography } from '@cleartrip/ct-design-components'
import { ErrorIcon } from '@/assets/icons/ErrorIcon'

const FilterErrorFallback = () => {
  return (
    <Container
      role='alert'
      aria-live='polite'
      className='flex flex-column flex-middle oy-hidden mx-4'
    >
      <Container className='flex flex-middle flex-center' css={{ transform: 'scale(0.72)' }}>
        <ErrorIcon />
      </Container>
      <Typography variant='HM3' className='mt-5 ta-center'>
        Could not load filters
      </Typography>
      <Typography variant='P3' color='subheading' className='mt-3 ta-center'>
        Something went wrong while loading filter options.
      </Typography>

    </Container>
  )
}

export default FilterErrorFallback
